import Events from 'events';

import SessionManager from './session_manager';

const NAMESPACE = 'urn:x-cast:tv.teamhub';

class MessageManager extends Events.EventEmitter {
  constructor() {
    super();

    this._session = null;

    this.MESSAGE_RECEIVED = 'messageReceived';
  }

  init() {
    const sessionChangedListener = this._sessionChangedListener.bind(this);

    SessionManager.on(SessionManager.SESSION_CHANGED, sessionChangedListener);
  }

  _sessionChangedListener(session) {
    const messageListener = this._messageListener.bind(this);

    if (this._session) {
      this._session.removeMessageListener(NAMESPACE, messageListener);
    }

    this._session = session;

    if (this._session) {
      this._session.addMessageListener(NAMESPACE, messageListener);
    }
  }

  _messageListener(namespace, message) {
    const data = JSON.parse(message);

    this.emit(this.MESSAGE_RECEIVED, data.subject, data.payload);
  }

  addMessageListener(listener) {
    this.on(this.MESSAGE_RECEIVED, listener);
  }

  sendMessage(data) {
    if (this._session) {
      const message = JSON.stringify(data);

      return this._session.sendMessage(NAMESPACE, message);
    }

    return Promise.reject(new Error('Session unavailable.'));
  }
}

export default new MessageManager();



// WEBPACK FOOTER //
// ./src/services/chromecast/message_manager.js